import React from 'react';

const PartsSection = ({
  partsValue,
  periodTotalUsedQty,
  periodTotalUsedCost,
  usedPartsPeriod,
  setUsedPartsPeriod,
  usedPartsDate,
  setUsedPartsDate,
  aggregatedPartsRanking,       
  usedPartsModelFilter,         
  setUsedPartsModelFilter,      
  usedPartsSearch,              
  setUsedPartsSearch,           
  selectedModel,
  setSelectedModel,
  filteredParts,
  filteredTotalValue,
  handlePrintUsedParts,
  handleDownloadUsedPartsExcel,
  handlePrintStockParts,
  handleDownloadStockPartsExcel
}) => {
  const style = {
    grid3: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '25px', marginBottom: '30px' },
    card: { background: 'white', padding: '30px', borderRadius: '20px', boxShadow: '0 4px 25px rgba(0,0,0,0.05)', marginBottom: '30px' },
    kpiCard: { padding: '25px', borderRadius: '15px', color: 'white', display: 'flex', flexDirection: 'column', minHeight: '130px', justifyContent: 'center', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' },
    kpiTitle: { fontSize: '13px', fontWeight: '700', opacity: 0.85, marginBottom: '10px', letterSpacing: '0.5px' },
    kpiValue: { fontSize: '26px', fontWeight: 'bold' },
    actionPrintBtn: { padding: '10px 18px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '5px' },
    actionExcelBtn: { padding: '10px 18px', background: '#10b981', color: 'white', border: 'none', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '5px' },
    tabButton: (isActive) => ({
      padding: '6px 12px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold',
      background: isActive ? '#1e293b' : 'transparent',
      color: isActive ? 'white' : '#64748b',
      transition: 'all 0.2s'
    }),
    input: { padding: '10px 15px', border: '1px solid #cbd5e1', borderRadius: '8px', outline: 'none', fontSize: '14px', background: 'white' },
    table: { width: '100%', borderCollapse: 'collapse', marginTop: '15px' },
    th: { background: '#f8fafc', padding: '14px 12px', textAlign: 'left', color: '#64748b', fontSize: '13px', fontWeight: 'bold', borderBottom: '2px solid #e2e8f0' },
    td: { padding: '14px 12px', fontSize: '14px', borderBottom: '1px solid #f1f5f9', color: '#1e293b' },
    badgeDanger: { background: '#fee2e2', color: '#ef4444', padding: '4px 8px', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold', marginLeft: '8px' },
    badgeSafe: { background: '#ecfdf5', color: '#10b981', padding: '4px 8px', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold', marginLeft: '8px' }
  };

  return (
    <>
      <div style={style.grid3}>
        <div style={{...style.kpiCard, background: 'linear-gradient(135deg, #1e293b, #334155)'}}>
          <div style={style.kpiTitle}>📦 총 부품 자산 평가액</div>
          <div style={style.kpiValue}>₩ {partsValue.total.toLocaleString()} 원</div>
        </div>
        <div style={{...style.kpiCard, background: 'linear-gradient(135deg, #3b82f6, #2563eb)'}}>
          <div style={style.kpiTitle}>🔄 선택 조건(기간/필터) 총 소진량</div>
          <div style={style.kpiValue}>{periodTotalUsedQty} EA 소진</div>
        </div>
        <div style={{...style.kpiCard, background: 'linear-gradient(135deg, #ef4444, #dc2626)'}}>
          <div style={style.kpiTitle}>📉 선택 조건 부품 누적 소진 원가</div>
          <div style={style.kpiValue}>₩ {periodTotalUsedCost.toLocaleString()} 원</div>
        </div>
      </div>

      <div style={style.card}>
        <div style={{display:'flex', flexDirection: 'column', gap: '15px', marginBottom:'20px'}}>
          <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
            <h3 style={{margin: 0, fontSize: '16px'}}>🛠️ 수요 예측을 위한 기간/차종별 부품 소진 랭킹 및 재고 현황</h3>
            <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
              <button style={style.actionPrintBtn} onClick={handlePrintUsedParts}>🖨️ 랭킹 분석표 출력</button>
              <button style={style.actionExcelBtn} onClick={handleDownloadUsedPartsExcel}>📊 랭킹 EXCEL 다운로드</button>
            </div>
          </div>
          
          <div style={{display:'flex', justifyContent:'flex-end', gap: '10px', alignItems: 'center', background: '#f8fafc', padding: '12px', borderRadius: '12px', border: '1px solid #e2e8f0'}}>
             <span style={{fontSize: '13px', fontWeight: 'bold', color: '#64748b'}}>🔍 정밀 분석 필터:</span>
             <select style={{...style.input, width: '150px', padding: '8px'}} value={usedPartsModelFilter} onChange={e=>setUsedPartsModelFilter(e.target.value)}>
                <option value="전체">전체 차종</option>
                {Object.keys(partsValue.byModel).map(m=><option key={m} value={m}>{m}</option>)}
             </select>
             <span style={{color:'#cbd5e1', margin: '0 5px'}}>|</span>
             <div style={{display: 'flex', background: 'white', border: '1px solid #cbd5e1', borderRadius: '8px', overflow: 'hidden'}}>
               {/* 🚀 전체, 하절기, 동절기 버튼 추가 적용 */}
               <button style={style.tabButton(usedPartsPeriod==='전체')} onClick={()=>setUsedPartsPeriod('전체')}>전체</button>
               <button style={style.tabButton(usedPartsPeriod==='일일')} onClick={()=>setUsedPartsPeriod('일일')}>일일</button>
               <button style={style.tabButton(usedPartsPeriod==='주간')} onClick={()=>setUsedPartsPeriod('주간')}>주간</button>
               <button style={style.tabButton(usedPartsPeriod==='월간')} onClick={()=>setUsedPartsPeriod('월간')}>월간</button>
               <button style={style.tabButton(usedPartsPeriod==='하절기')} onClick={()=>setUsedPartsPeriod('하절기')}>하절기</button>
               <button style={style.tabButton(usedPartsPeriod==='동절기')} onClick={()=>setUsedPartsPeriod('동절기')}>동절기</button>
             </div>
             
             {/* 🚀 '전체'가 아닐 때만 동적으로 입력창 렌더링. 하절기/동절기 선택 시 연도(Year) 입력기로 변신 */}
             {usedPartsPeriod !== '전체' && (
               <input 
                 type={(usedPartsPeriod === '하절기' || usedPartsPeriod === '동절기') ? "number" : (usedPartsPeriod === '월간' ? "month" : "date")} 
                 style={{...style.input, width: '130px', padding: '8px'}} 
                 value={(usedPartsPeriod === '하절기' || usedPartsPeriod === '동절기') ? usedPartsDate.substring(0,4) : (usedPartsPeriod === '월간' ? usedPartsDate.substring(0,7) : usedPartsDate)} 
                 onChange={e => {
                   const val = e.target.value;
                   if (usedPartsPeriod === '하절기' || usedPartsPeriod === '동절기') {
                     setUsedPartsDate(`${val}-01-01`); // 데이터 정합성을 위해 1월 1일 포맷으로 캡슐화
                   } else if (usedPartsPeriod === '월간') {
                     setUsedPartsDate(val.length === 7 ? `${val}-01` : val);
                   } else {
                     setUsedPartsDate(val);
                   }
                 }} 
               />
             )}
             <input style={{...style.input, width: '220px', padding: '8px'}} placeholder="부품명 검색..." value={usedPartsSearch} onChange={e=>setUsedPartsSearch(e.target.value)} />
          </div>
        </div>

        <div style={{maxHeight:'300px', overflowY:'auto', border: '1px solid #edf2f7', borderRadius: '12px'}}>
          <table style={style.table}>
            <thead style={{position: 'sticky', top: 0, background: '#f8fafc', zIndex: 5}}>
              <tr style={{borderBottom: '2px solid #eee'}}>
                <th style={{...style.th, textAlign: 'center', width: '60px'}}>순위</th>
                <th style={style.th}>차종(모델)</th>
                <th style={{...style.th, width: '35%'}}>부품명 (소진 대상)</th>
                <th style={{...style.th, textAlign:'center'}}>총 소진 수량</th>
                <th style={{...style.th, textAlign:'center'}}>현재 보유 재고 (비교)</th>
                <th style={{...style.th, textAlign:'right', paddingRight: '20px'}}>소진 원가 합계</th>
              </tr>
            </thead>
            <tbody>
              {aggregatedPartsRanking.map((p, idx) => {
                const isShortage = p.currentStock < p.totalQty; 
                
                return (
                  <tr key={idx} style={{borderBottom: '1px solid #f1f5f9'}}>
                    <td style={{...style.td, textAlign: 'center', fontWeight: 'bold', color: idx < 3 ? '#3b82f6' : '#64748b'}}>{idx + 1}위</td>
                    <td style={{...style.td, color: '#64748b'}}>{p.modelName}</td>
                    <td style={style.td}><b>{p.partName}</b></td>
                    <td style={{...style.td, textAlign:'center', fontWeight: 'bold', color: '#ef4444', fontSize: '15px'}}>{p.totalQty} EA</td>
                    <td style={{...style.td, textAlign:'center'}}>
                      <span style={{ fontWeight: 'bold', color: isShortage ? '#ef4444' : '#10b981' }}>{p.currentStock} EA</span>
                      {isShortage && <span style={style.badgeDanger}>발주 필요</span>}
                    </td>
                    <td style={{...style.td, textAlign:'right', fontWeight:'bold', paddingRight: '20px'}}>₩ {p.totalCost.toLocaleString()}</td>
                  </tr>
                );
              })}
              {aggregatedPartsRanking.length === 0 && <tr><td colSpan="6" style={{...style.td, textAlign:'center', color:'#94a3b8', padding: '40px'}}>지정 조건에 해당하는 부품 소진 데이터가 없습니다.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      <div style={style.card}>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'20px'}}>
          <h3 style={{margin:0, fontSize:'16px'}}>🚗 전체 부품 마스터 재고 및 자산 현황</h3>
          <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
            <button style={style.actionPrintBtn} onClick={handlePrintStockParts}>🖨️ 출력하기</button>
            <button style={style.actionExcelBtn} onClick={handleDownloadStockPartsExcel}>📊 EXCEL 다운로드</button>
            <span style={{color:'#cbd5e1', margin:'0 5px'}}>|</span>
            <select style={style.input} value={selectedModel} onChange={e=>setSelectedModel(e.target.value)}>
              <option value="전체">전체 차종</option>
              {Object.keys(partsValue.byModel).map(m=><option key={m} value={m}>{m}</option>)}
            </select>
          </div>
        </div>
        <div style={{maxHeight:'350px', overflowY:'auto', border: '1px solid #edf2f7', borderRadius: '12px'}}>
          <table style={style.table}>
            <thead style={{position: 'sticky', top: 0, background: '#f8fafc', zIndex: 5}}>
              <tr style={{borderBottom: '2px solid #eee'}}>
                <th style={style.th}>모델</th>
                <th style={style.th}>부품명 / 코드</th>
                <th style={style.th}>현재고</th>
                <th style={{...style.th, textAlign:'right', paddingRight: '20px'}}>재고 평가액</th>
              </tr>
            </thead>
            <tbody>
              {filteredParts.map((p, idx)=>(
                <tr key={idx} style={{borderBottom: '1px solid #f1f5f9'}}>
                  <td style={style.td}>{p.modelName || '공용'}</td>
                  <td style={style.td}><b>{p.partName}</b><br/><span style={{fontSize:'11px', color:'#94a3b8'}}>{p.partNo}</span></td>
                  <td style={{...style.td, fontWeight:'bold', color:p.currentStock===0?'red':'#1e293b'}}>{p.currentStock} EA</td>
                  <td style={{...style.td, textAlign:'right', fontWeight:'bold', paddingRight: '20px'}}>₩ {p.value.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={{textAlign:'right', marginTop:'20px', fontSize:'16px', fontWeight:'bold', color:'#3b82f6'}}>
          선택 차종 자산 총액: ₩ {filteredTotalValue.toLocaleString()} 원
        </div>
      </div>
    </>
  );
};

export default PartsSection;